import { Plugin, PluginKey } from 'prosemirror-state';
import { DecorationSet, Decoration } from 'prosemirror-view';

export const placeholderPluginKey = new PluginKey('placeholderPlugin');

const placeholderPlugin = (placeholderText) =>

	new Plugin({

		key: placeholderPluginKey,

		props: {

			decorations(state) {

				const { doc } = state;

				if (doc.childCount > 1 || !doc.firstChild.isTextblock || doc.firstChild.content.size > 0) {

					return null;

				}

				const placeholder = document.createElement('span');

				placeholder.className = 'text-editor-placeholder';
				placeholder.dataset.placeholder = placeholderText || '';

				return DecorationSet.create(doc, [Decoration.widget(1, placeholder, { side: -1 })]);

			}

		},

	});

export default placeholderPlugin;
